define(function() {
  'use-strict';
  return function(options, element) {
    const menuMainClass     = options.menuClass,
        dropdownItem      = element.querySelectorAll(`.${menuMainClass}__item--parent > .${menuMainClass}__label`),
        dropdownInnerItem = element.querySelectorAll(`.${menuMainClass}__inner-item--parent.${menuMainClass}__inner-item--level1 > .${menuMainClass}__inner-label`),
        dropdownInnerInnerItem = element.querySelectorAll(`.${menuMainClass}__inner-item--parent.${menuMainClass}__inner-item--level2 > .${menuMainClass}__inner-label`),
        activeClass       = 'open',
        innerListLevel1   = `.${menuMainClass}__inner-list--level1`,
        innerListLevel2   = `.${menuMainClass}__inner-list--level2`,
        innerListLevel3   = `.${menuMainClass}__inner-list--level3`;

    function setListHeight(item) {
      return Array.from(item.children)
        .map(elem => elem.clientHeight)
        .reduce((a, b) => a + b, 0);
    }

    function setAriaAttributes(label, content, expanded) {
      if (expanded) {
        label.setAttribute('aria-expanded', 'false')
        content.setAttribute('aria-hidden', 'true');
      }
      else {
        label.setAttribute('aria-expanded', 'true');
        content.setAttribute('aria-hidden', 'false');
      }
    }

    function toggleSubmenu(item, level) {
      const dropdownId = item.dataset.dropdown;
      let dropdownList,
          parentList,
          innerList,
          isOpen;

      if (level === 'l0') {
        dropdownList = document.querySelector(`${innerListLevel1}[data-dropdown="${dropdownId}"]`);
        innerList   = item.parentNode.querySelectorAll(innerListLevel2);
        parentList    = null;
      }
      if (level === 'l1') {
        dropdownList = item
          .parentNode
          .querySelector(`${innerListLevel2}[data-dropdown="${dropdownId}"]`);
        innerList = null;
        parentList  = item.closest(innerListLevel1);
      }
      if (level === 'l2' ) {
        dropdownList = item
          .parentNode
          .querySelector(`${innerListLevel3}[data-dropdown="${dropdownId}"]`);
        innerList = null;
        parentList  = item.closest(innerListLevel2);
      }
      item.parentNode.classList.toggle(activeClass);
      isOpen = dropdownList.clientHeight > 0;

      if (dropdownList && isOpen) {
        if (innerList) {
          innerList.forEach(list => {
            list.style.height = 0;
            list.parentNode.classList.remove(activeClass);

            const innerListLabel = list
              .parentNode
              .querySelector(`[data-dropdown="${list.dataset.dropdown}"]`);

            setAriaAttributes(innerListLabel, list, true);
          });
        }
        else if (parentList) {
          parentList.style.height = parentList.clientHeight - dropdownList.clientHeight + 'px';
        }

        dropdownList.style.height = 0;
        const listLabel = dropdownList
          .parentNode
          .querySelector(`[data-dropdown="${dropdownList.dataset.dropdown}"]`);

        setAriaAttributes(listLabel, dropdownList, true);
      }

      else if (dropdownList && !isOpen) {
        const listHeight = setListHeight(dropdownList);
        const listLabel = dropdownList
          .parentNode
          .querySelector(`[data-dropdown="${dropdownList.dataset.dropdown}"]`);

        dropdownList.style.height = listHeight + 'px';
        setAriaAttributes(listLabel, dropdownList, false);

        if (parentList) {
          parentList.style.height = parentList.clientHeight + listHeight + 'px';
        }
      }
    }

    dropdownItem.forEach(
      key => key.addEventListener('click', (e) => {
        e.preventDefault();
        toggleSubmenu(key, 'l0');
      }, false)
    );

    dropdownInnerItem.forEach(
      key => key.addEventListener('click', (e) => {
        e.preventDefault();
        toggleSubmenu(key, 'l1');
      }, false)
    );

    dropdownInnerInnerItem.forEach(
      key => key.addEventListener('click', (e) => {
        e.preventDefault();
        toggleSubmenu(key, 'l2');
      }, false)
    );
  }
})
